import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'
import Dropdown1 from 'srcReact/components/common2/Dropdown1'
import colorVariables from 'srcReact/assets/scss/global/base/_variables.scss'

function OrderByDropdown({ options = null, selected = '', className, containerClassName, handleOrderByChange }) {
  const { t } = useTranslation()
  const [selectedOrderBy, setSelectedOrderBy] = useState({
    value: 'last_joined',
    label: t('orderBy.lastJoined')
  })

  const [orderByOptions, setOrderByOptions] = useState([
    {
      value: 'last_joined',
      label: t('orderBy.lastJoined')
    },
    { value: 'name', label: t('orderBy.name') },
    {
      value: 'shared_interests',
      label: t('orderBy.interests')
    }
  ])

  useEffect(() => {
    if (selected) {
      const selectedObj = orderByOptions.find((o) => o.value === selected)
      setSelectedOrderBy(selectedObj)
    }
  }, [selected])

  useEffect(() => {
    if (options) {
      setOrderByOptions(options)
      setSelectedOrderBy(selected)
    }
  }, [options])
  const handleOrderBy = (order) => {
    setSelectedOrderBy(order)
    if (handleOrderByChange) {
      handleOrderByChange(order)
    }
  }

  return (
    <div className={`${styles.orderByContainer} ${containerClassName}`}>
      <label htmlFor='orderByDropdown'>{t('orderBy.title')}:</label>
      <Dropdown1
        id='orderByDropdown'
        options={orderByOptions}
        className={`${styles.dropdown} ${className}`}
        onChange={handleOrderBy}
        value={selectedOrderBy}
        aria-label={t('orderBy.title')}
      />
    </div>
  )
}

export default OrderByDropdown
